var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"beian"},[_c('div',{staticClass:"ba_main"},[_c('div',{staticClass:"balist"}),_vm._v(" "),_c('div',{staticClass:"balist",on:{"click":_vm.getICP}},[_vm._v("蜀ICP备 12028597号")]),_vm._v(" "),_c('div',{staticClass:"balist"},[_vm._v("版权所有©四川大学锦江学院")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0db7fe74","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/beian.vue
// module id = null
// module chunks = 